import React from 'react';
import { ImageRotator } from '@ui';

interface HeroImageRotatorProps {
  images?: Array<{
    id: number;
    title: string;
    image_url: string;
    image_url_2x?: string;
  }>;
}

const HeroImageRotator: React.FC<HeroImageRotatorProps> = ({ images = [] }) => {
  const rotatorImages = images.map((img) => ({
    src: img.image_url,
    ...(img.image_url_2x ? { src2x: img.image_url_2x } : {}),
    alt: img.title,
  }));

  return (
    <ImageRotator
      className='hero-image-rotator'
      images={rotatorImages}
      interval={3200}
      transition='dissolve'
      transitionDuration={650}
      width='100%'
      height='auto'
    />
  );
};

export default HeroImageRotator;
